
import { Card, Flex, Tag, Avatar, Button, Dropdown, theme, Typography } from "antd";
import { CalendarOutlined, UserOutlined, MoreOutlined } from "@ant-design/icons";
import type { Contract, ContractStatus } from "../types";
import { HybridCard } from "../../shared";

const statusConfig: Record<
  ContractStatus,
  { label: string; tagColor: string }
> = {
  vigente: { label: "Vigente", tagColor: "success" },
  por_vencer: { label: "Por Vencer", tagColor: "error" },
  finalizado: { label: "Finalizado", tagColor: "default" },
};

const { Text } = Typography;

interface ContractCardProps {
  contract: Contract;
  onClick?: () => void;
}

const ContractCard = ({ contract, onClick }: ContractCardProps) => {
  const { token } = theme.useToken();
  const cfg = statusConfig[contract.status];
  const status = contract.status === "vigente" ? "active" : contract.status === "por_vencer" ? "warning" : undefined;
  const isWarning = contract.status === "por_vencer";

  const avatarBg =
    contract.status === "vigente"
      ? token.colorPrimaryBg
      : contract.status === "por_vencer"
        ? token.colorErrorBg
        : token.colorFillSecondary;

  const avatarColor =
    contract.status === "vigente"
      ? token.colorPrimary
      : contract.status === "por_vencer"
        ? token.colorError
        : token.colorTextSecondary;

  return (
    <HybridCard
      key={contract.id}
      status={status}
      icon={<Avatar
        size={56}
        icon={contract.icon}
        style={{
          backgroundColor: avatarBg,
          color: avatarColor,
          fontSize: 22,
          borderRadius: token.borderRadiusLG,
          flexShrink: 0,
        }}
      />}
      title={contract.title}
      onClick={onClick}
      swipe={{ onView: onClick }}
      tagStatus={<Tag
        color={cfg.tagColor}
        style={{
          fontWeight: 700,
          fontSize: 11,
          borderRadius: 999,
          margin: 0,
        }}
      >
        {cfg.label}
      </Tag>}
      description={<Text
        type="secondary"
        style={{
          fontSize: 12,
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        <CalendarOutlined
          style={{ color: isWarning ? token.colorError : undefined }}
        />
        {contract.expiresLabel}
      </Text>}
      subtitle={contract.client_name && (
        <Text
          type="secondary"
          style={{
            fontSize: 12,
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <UserOutlined />
          {contract.clientLabel}: {contract.client_name}
        </Text>
      )}
    >
    </HybridCard>
  );
};

export default ContractCard;
